//#region import libraries
import React, { useState, useEffect } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// custom components
import { ProductForm, PricingForm, DistributionForm } from '_organisms';


// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectCreateProductStatus, selectCreateProduct, selectDistributionStatus, selectPricingStatus, resetProduct } from '_redux/slices/marketplace/create-product'

//#endregion

const CreateProduct = (props) => {

    //#region local states
    const [screen, setScreen] = useState('default');
    const [submitted, setSubmitted] = useState(false);
    //#endregion

    //#region redux
    const dispatch = useDispatch()
    // create product redux
    const product = useSelector(selectCreateProduct)
    const createProductStatus = useSelector(selectCreateProductStatus)

    // distribution redux
    const distributionStatus = useSelector(selectDistributionStatus)

    // pricing redux
    const pricingStatus = useSelector(selectPricingStatus);
    //#endregion

    //#region useEffects
    useEffect(() => {
        if (createProductStatus == 'succeeded' && submitted) {
            setScreen('distribution-form');
        }
    }, [createProductStatus]);

    useEffect(() => {
        if (distributionStatus == 'succeeded' && submitted) {
            setScreen('pricing-form');
        }
    }, [distributionStatus]);

    useEffect(() => {
        if (pricingStatus == 'succeeded' && submitted) {
            props.createdProduct(product.id)
            //props.back()
            dispatch(resetProduct())
        }
    }, [pricingStatus]);
    //#endregion

    return (
        <>
            <Row className='mt-3'>

                <Row className='mt-4' style={{ marginBottom: 200 }}>
                    <Col>
                        <Form>
                            {screen == 'default' && <ProductForm submitted={() => { setSubmitted(true) }} back={() => { props.back() }} />}
                            {screen == 'distribution-form' && <DistributionForm back={() => { setScreen('default') }} />}
                            {screen == 'pricing-form' && <PricingForm back={() => { setScreen('distribution-form') }} />}
                        </Form>
                    </Col>
                </Row>
            </Row>
        </>
    );
}


export default CreateProduct;
